import { useCallback, useMemo } from "react";

import { SelectAllOption } from "ds/components/Table/types";
import { FlowsProjectRoleBindingView } from "shared/Flows/Projects/useFlowsProject/types";

import useFlowsProjectRolesTableSelectionStore from "./useSelectionStore";

type UseFlowsProjectRolesSelectionOptionsResult = {
  selectionOptions: SelectAllOption[];
  rolesMap: Map<string, FlowsProjectRoleBindingView>;
};

const useFlowsProjectRolesSelectionOptions = (
  roles: FlowsProjectRoleBindingView[]
): UseFlowsProjectRolesSelectionOptionsResult => {
  const { replaceSelected } = useFlowsProjectRolesTableSelectionStore();

  const selectAllItems = useCallback(async () => {
    replaceSelected(roles.map((role) => role.id));
  }, [replaceSelected, roles]);

  const rolesMap = useMemo(() => new Map(roles.map((role) => [role.id, role])), [roles]);

  const selectionOptions = useMemo(
    () => [
      {
        title: "Select all roles",
        onSelect: selectAllItems,
      },
    ],
    [selectAllItems]
  );

  return {
    selectionOptions,
    rolesMap,
  };
};

export default useFlowsProjectRolesSelectionOptions;
